import { render } from "./LoginPage.vue?vue&type=template&id=f4f0a36e&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=f4f0a36e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f0a36e"]])

export default __exports__